import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.SinglePage,
  title: 'Single Page',
  category: ComponentCategory.Layout,
  showInLibrary: false,
};
